const chunkCardData = (array) => {
  if (!array) {
    return;
  }
  const chunkedArr = [];
  let index = 0;
  while (index < array.length) {
    chunkedArr.push(array.slice(index, 2 + index));
    index += 2;
  }
  // eslint-disable-next-line consistent-return
  return chunkedArr;
};

const cardValues = [
  { label: '2', value: 101 },
  { label: '3', value: 102 },
  { label: '4', value: 103 },
  { label: '5', value: 104 },
  { label: '6', value: 105 },
  { label: '7', value: 106 },
  { label: '8', value: 107 },
  { label: '9', value: 108 },
  { label: 'T', value: 109 },
  { label: 'J', value: 110 },
  { label: 'Q', value: 111 },
  { label: 'K', value: 112 },
  { label: 'A', value: 113 },
];

function countInArray(array, what) {
  let count = 0;
  for (let i = 0; i < array.length; i += 1) {
    if (array[i] === what) {
      count += 1;
    }
  }
  return count;
}

// eslint-disable-next-line import/prefer-default-export
export const sortCards = (cards, isPlo5 = false, defaultSort = false) => {
  if (!cards) return '';
  const chunckedCards = chunkCardData(cards);
  if (defaultSort) {
    const sortedCards = chunckedCards.sort((card1, card2) => {
      const card1Value = () => {
        const { value } = cardValues.find((card) => card.label === card1[0]);
        return value;
      };
      const card2Value = () => {
        const { value } = cardValues.find((card) => card.label === card2[0]);
        return value;
      };
      return card2Value() - card1Value();
    });
    return sortedCards;
  }
  const sortedCards = chunckedCards.sort((card1, card2) => {
    const card1Value = () => {
      const { value } = cardValues.find((card) => card.label === card1[0]);
      return value * countInArray(cards, card1[0]);
    };
    const card2Value = () => {
      const { value } = cardValues.find((card) => card.label === card2[0]);
      return value * countInArray(cards, card2[0]);
    };
    return card2Value() - card1Value();
  });
  if (isPlo5) {
    // eslint-disable-next-line no-use-before-define
    return applyPlo5Sort(sortedCards);
  }
  return sortedCards;
};

// eslint-disable-next-line import/prefer-default-export
export const sortRawCards = (cards) => {
  if (!cards) return '';
  const sortedCards = cards.sort((card1, card2) => {
    const card1Value = () => {
      const { value } = cardValues.find((card) => card.label === card1[0]);
      return value * countInArray(cards, card1[0]);
    };
    const card2Value = () => {
      const { value } = cardValues.find((card) => card.label === card2[0]);
      return value * countInArray(cards, card2[0]);
    };
    return card2Value() - card1Value();
  });
  return sortedCards;
};

function applyPlo5Sort(cards) {
  if (!cards) {
    return '';
  }
  const card1 = cards[0];
  const card2 = cards[1];
  const card3 = cards[2];
  const card4 = cards[3];
  const card5 = cards[4];

  if (!card1 || !card2 || !card3 || !card4 || !card5) {
    return [];
  }

  if (card1[0] === card2[0]) {
    const arr = sortCards(`${card3}${card4}${card5}`, false);
    if (arr[0][0] === arr[1][0]) {
      const value1 = cardValues.find((card) => card.label === card1[0]).value;
      const value2 = cardValues.find((card) => card.label === arr[0][0]).value;
      if (value1 > value2) {
        return [card1, card2, arr[0], arr[1], arr[2]];
      }
      return [arr[0], arr[1], card1, card2, arr[2]];
    }
    return [card1, card2, arr[0], arr[1], arr[2]];
  }
  return cards;
}
